export default async function (context) {
  const token = context.route.params.token

  const { success } = await context.$userMS.getInvitationByToken({ token })

  if (!success) {
    return context.redirect('/404')
  }
}
